import { useContext } from 'react';
import { ContextType, FlashMessageContext } from './context';

export const useFlashMessageScope = (): ContextType => {
  return useContext(FlashMessageContext);
};
